// exportSalaryToExcel.ts
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import moment from 'moment'

export interface SalaryExportRow {
    documentNo: string
    monthly: string   // YYYY-MM
    documentDate: string   // ISO
    total: number
    status: string
    updatedBy: string
    updatedAt: string   // ISO
}

export interface SalaryExportReport {
    title: string      // e.g. "เงินเดือนทันตแพทย์"
    filters: string    // e.g. ["ค้นหา: …", "สาขา: …", "เดือน: …"]
    rows: SalaryExportRow[],
    t: any
}

export async function exportSalaryToExcel(rpt: SalaryExportReport) {
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet(rpt.title, {
        pageSetup: { orientation: 'landscape' }
    })
    ws.properties.defaultRowHeight = 18

    // 1) คอลัมน์ A–G
    ws.columns = [
        { header: '#', width: 6 },
        { header: rpt.t('SALARY.TABLE.CELL.HEADER.DOCUMENT_NO'), width: 20 },
        { header: rpt.t('SALARY.TABLE.CELL.HEADER.MONTHLY'), width: 15 },
        { header: rpt.t('SALARY.TABLE.CELL.HEADER.DOCUMENT_CREATION_DATE'), width: 25 },
        { header: rpt.t('SALARY.TABLE.CELL.HEADER.TOTAL'), width: 15 },
        { header: rpt.t('SALARY.TABLE.CELL.HEADER.DOCUMENT_STATUS'), width: 20 },
        { header: rpt.t('SALARY.TABLE.CELL.HEADER.CREATED_BY'), width: 30 }
    ] as ExcelJS.Column[]

    let r = 1

    // 2) Title (A1–G1)
    ws.mergeCells(r, 1, r, ws.columns.length)
    ws.getCell(r, 1).value = rpt.title
    ws.getCell(r, 1).font = { size: 16, bold: true }
    ws.getCell(r, 1).alignment = { horizontal: 'center', vertical: 'middle' }
    r++

    // 3) Filters row (A2–G2)
    ws.mergeCells(r, 1, r, ws.columns.length)
    ws.getCell(r, 1).value = rpt.filters
    ws.getCell(r, 1).font = { size: 12 }
    ws.getCell(r, 1).alignment = { horizontal: 'left', vertical: 'middle' }
    r += 2

    // 4) Header row
    const header = ws.addRow(ws.columns.map(c => c.header as string))
    header.font = { bold: true }
    header.alignment = { horizontal: 'center', vertical: 'middle' }
    header.height = 20
    header.eachCell(cell => {
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    })
    r++


    if (!rpt.rows || rpt.rows.length === 0) {
        const noDataRow = ws.addRow([rpt.t('REPORT.TITLE.NO_DATA')])
        ws.mergeCells(noDataRow.number, 1, noDataRow.number, ws.columns.length)
        noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
        noDataRow.alignment = { horizontal: 'center' }
        const buf = await wb.xlsx.writeBuffer()
        saveAs(
            new Blob([buf]),
            `${rpt.title}_${moment().format('YYYYMMDD')}.xlsx`
        )
        return
    }

    // 5) Data rows
    rpt.rows.forEach((d, i) => {
        const row = ws.addRow([
            i + 1,
            d.documentNo,
            d.monthly,
            d.documentDate,
            d.total,
            d.status,
            `${d.updatedBy} ${d.updatedAt}`
        ])
        row.alignment = { vertical: 'middle' }
        row.eachCell((cell, col) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
            if (col === 1 || col === 6 || col === 7) {
                cell.alignment = { horizontal: 'center', vertical: 'middle' }
            } else if (col === 5) {
                // total
                cell.numFmt = '#,##0.00'
                cell.alignment = { horizontal: 'right', vertical: 'middle' }
            } else {
                cell.alignment = { horizontal: 'left', vertical: 'middle' }
            }
        })
    })

    // 6) Save
    const buf = await wb.xlsx.writeBuffer()
    saveAs(
        new Blob([buf]),
        `${rpt.title}_${moment().format('YYYYMMDD')}.xlsx`
    )
}
